import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { popularKeywords } from "@/mocks/filters";

export default function SearchBand() {
  const navigate = useNavigate();
  const [keyword, setKeyword] = useState("");

  const go = (value: string) => {
    const q = value.trim();
    if (!q) return;
    navigate(`/search?q=${encodeURIComponent(q)}`);
  };

  return (
    <section className="mx-auto w-full max-w-[1280px] px-4 pt-8 md:px-8 md:pt-10">
      <div className="rounded-lg border border-background-200/70 bg-background-100/60 p-5 md:p-7">
        <div className="flex items-center gap-2">
          <i className="ri-search-eye-line text-xl text-primary-700" />
          <h2 className="font-heading text-lg font-bold text-foreground-950">搜索你想看的影视</h2>
        </div>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            go(keyword);
          }}
          className="mt-4 flex flex-col gap-3 sm:flex-row"
        >
          <div className="flex flex-1 items-center gap-2 rounded-full border border-background-300/70 bg-background-50 px-4 py-3 focus-within:border-primary-400">
            <i className="ri-search-line text-lg text-foreground-500" />
            <input
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              type="search"
              placeholder="输入影片名称、演员或题材关键词"
              className="w-full bg-transparent text-sm text-foreground-900 outline-none placeholder:text-foreground-500"
            />
          </div>
          <button
            type="submit"
            className="flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-accent-500 px-7 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-accent-600"
          >
            <i className="ri-search-line" />
            立即搜索
          </button>
        </form>
        <div className="mt-4 flex flex-wrap items-center gap-2">
          <span className="text-xs text-foreground-500">热门搜索：</span>
          {popularKeywords.map((word) => (
            <button
              key={word}
              type="button"
              onClick={() => go(word)}
              className="rounded-full border border-background-300/70 bg-background-50 px-3 py-1 text-xs text-foreground-700 transition-colors hover:border-secondary-300 hover:bg-secondary-100 hover:text-secondary-800"
            >
              {word}
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}